const validateOnlyNumbers = (rule, value) => (value ? !/\D/g.test(value) : true);

export default validateOnlyNumbers;
